export const STORE_OFFERS = 'STORE_OFFERS';
export const CLEAR_OFFERS = 'CLEAR_OFFERS';
export const REQUEST_OFFERS = 'REQUEST_OFFERS';
export const UPDATE_OFFER_LIST = 'UPDATE_OFFER_LIST';
export const TERMINATE_FETCHING = 'TERMINATE_FETCHING';
export const RESET_NEW_OFFERS = 'RESET_NEW_OFFERS';
export const SET_SHOW_OFFER_SUCCESS = 'SET_SHOW_OFFER_SUCCESS';
export const SET_SHOW_CREATE_NEW_OFFER_MODAL = 'SET_SHOW_CREATE_NEW_OFFER_MODAL';
export const SET_SHOW_OFFER_ACCEPT_UNLOCK_MODAL = 'SET_SHOW_OFFER_ACCEPT_UNLOCK_MODAL';

export interface Items {
  items: unknown[];
}

export interface New {
  new: unknown[];
}

export interface Sent {
  sent: unknown[];
}

export interface Accepted {
  accepted: unknown[];
}

export interface Rejected {
  rejected: unknown[];
}

export interface Highlights {
  highlights: unknown[];
}

export interface IsFetching {
  isFetching: boolean;
}

export interface OfferType {
  offerType: string;
}

export interface OfferList {
  offerList: unknown[];
}

export interface offerPreFetchExpiration {
  offerPreFetchExpiration: number;
}

export interface offerSuccess {
  showOfferSuccess: {
    isOpen: boolean;
    isSuggest?: boolean;
    isCounter?: boolean;
    amount: string | number;
  };
}
export interface offerAcceptUnlock {
  showOfferAcceptUnlockModal: {
    isOpen: boolean;
    offerAmount?: any;
    creditCost?: any;
    hashId?: string;
    username?: string;
    urls?: any;
    forceTrigger: any;
    isGenerous: boolean;
  };
}

export interface showCreateOffer {
  showCreateNewOfferModal: boolean;
}

export interface Payload extends OfferType, OfferList {}

export interface OfferState
  extends Items,
    New,
    Sent,
    Accepted,
    Rejected,
    Highlights,
    IsFetching,
    offerPreFetchExpiration,
    offerSuccess,
    offerAcceptUnlock,
    showCreateOffer {}

interface STORE_OFFERS_ACTION {
  type: typeof STORE_OFFERS;
  firstCall: boolean;
  payload: unknown[];
  section: number | string;
  isFetching: IsFetching;
  isRealtimeEvent: boolean;
  offerPreFetchExpiration: number;
}

interface CLEAR_OFFERS_ACTION {
  type: typeof CLEAR_OFFERS;
  items: Items;
}

interface REQUEST_OFFERS_ACTION {
  type: typeof REQUEST_OFFERS;
  isFetching: IsFetching;
}

interface UPDATE_OFFER_LIST_ACTION {
  type: typeof UPDATE_OFFER_LIST;
  payload: Payload;
}

interface TERMINATE_FETCHING_ACTION {
  type: typeof TERMINATE_FETCHING;
}
interface RESET_NEW_OFFERS_ACTION {
  type: typeof RESET_NEW_OFFERS;
}
interface SET_SHOW_OFFER_SUCCESS_ACTION {
  type: typeof SET_SHOW_OFFER_SUCCESS;
  payload: {
    isOpen: boolean;
    isSuggest?: boolean;
    isCounter?: boolean;
    amount?: boolean;
  };
}
interface SET_SHOW_OFFER_ACCEPT_UNLOCK_ACTION {
  type: typeof SET_SHOW_OFFER_ACCEPT_UNLOCK_MODAL;
  payload: {
    isOpen: boolean;
    offerAmount?: any;
    creditCost?: any;
    hashId?: string;
    username?: string;
    urls?: any;
    forceTrigger: any;
    isGenerous: boolean;
    threadUid?: string;
  };
}
interface SET_SHOW_CREATE_NEW_OFFER_MODAL_ACTION {
  type: typeof SET_SHOW_CREATE_NEW_OFFER_MODAL;
  payload: boolean;
}

export type OfferActionTypes =
  | STORE_OFFERS_ACTION
  | CLEAR_OFFERS_ACTION
  | REQUEST_OFFERS_ACTION
  | UPDATE_OFFER_LIST_ACTION
  | TERMINATE_FETCHING_ACTION
  | RESET_NEW_OFFERS_ACTION
  | SET_SHOW_OFFER_SUCCESS_ACTION
  | SET_SHOW_CREATE_NEW_OFFER_MODAL_ACTION
  | SET_SHOW_OFFER_ACCEPT_UNLOCK_ACTION;
